import { render, staticRenderFns } from "./ListGeneral.vue?vue&type=template&id=e9a4f8dc&"
import script from "./ListGeneral.vue?vue&type=script&lang=js&"
export * from "./ListGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports